import React from "react";
import pen from "../../assets/pen-solid.svg";
import blackLogo from "../../assets/blacklogo.svg";
import "./RightSidebar.css";

const Widget = () => {
  
  return (
    <div className="widget">
      <h4>
        The Overflow Blog
      </h4>
      <div className="right-sidebar-div-1">
        <div className="right-sidebar-div-2">
          <img src={pen} alt="pen" width="10" />
          <p>
            How can you create input forms to appear row by row
          </p>
        </div>
        <div className="right-sidebar-div-2">
          <img src={pen} alt="pen" width="10" />
          <p>
            From Web2 to Web3: How developers can upskill and build with blockchain
          </p>
        </div>
      </div>
      <h4>
        Featured on Meta
      </h4>
      <div className="right-sidebar-div-1">
        <div className="right-sidebar-div-2">
          <img src={blackLogo} alt="pen" width="18" />
          <p>
            Do you observe increased relevance of Related Questions with our Machine...
          </p>
        </div>
        <div className="right-sidebar-div-2">
          <img src={blackLogo} alt="pen" width="18" />
          <p>
            Temporary policy: ChatGPT is banned for a limited time
          </p>
        </div>
        <div className="right-sidebar-div-2">
          <img src={blackLogo} alt="pen" width="18" />
          <p>
            Outdated Answers: accepted answer is now unpinned on Stack Overflow
          </p>
        </div>
      </div>
      <h4>
        Hot Meta Posts
      </h4>
      <div className="right-sidebar-div-1">
        <div className="right-sidebar-div-2">
          <p>
            36
          </p>
          <p>
            Why was this spam flag declined, yet the question marked as spam?
          </p>
        </div>
        <div className="right-sidebar-div-2">
          <p>
            24
          </p>
          <p>
            What is the best course of action when a user has high enough rep to...
          </p>
        </div>
        <div className="right-sidebar-div-2">
          <p>
            42
          </p>
          <p>
            Is a link to the "How to ask" help page a useful comment?
          </p>
        </div>
      </div>
    </div>
  );
};

export default Widget;